import { checkOrderCart } from '@/api/wave/orders';
import { PaymentOptionStore } from '@/store/sideSheet';
import { convertFromCents, formatNumber } from '@/utils/amountUtils';

const DEAFULT_COUPON_ERROR_MESSAGE = 'Υπήρξε πρόβλημα με τον έλεγχο του κουπονιού';

export async function checkCoupon(
  products,
  shopId,
  delivery,
  address,
  getCollectionTypes,
  coupon,
  setCouponError,
  setCouponDiscount,
  setCouponSuccess,
  bags,
  setPaymentOptions,
  paymentOptions,
  formatter,
  t,
  setCouponDiscountAmmount,
  setCouponIsEligible
) {
  const updatedProducts = products.map(product => {
    const { options, ...rest } = product;
    if (options && options.length > 0) {
      return {
        ...rest,
        options: options.map(opt => opt.id),
      };
    }
    return rest;
  });
  const res = await checkOrderCart(
    updatedProducts,
    shopId,
    delivery,
    'none',
    address,
    getCollectionTypes(),
    PaymentOptionStore.getValue()?.type,
    bags,
    coupon && coupon?.length > 0
      ? [...paymentOptions.filter(val => val.type !== 'COUPON'), { type: 'COUPON', value: coupon }]
      : [...paymentOptions.filter(val => val.type !== 'COUPON')]
  );
  if (coupon && coupon?.length > 0)
    setPaymentOptions(prev => [...prev.filter(val => val.type !== 'COUPON'), { type: 'COUPON', value: coupon }]);

  if (res.order?.paymentOptions) {
    const coupon = res.order.paymentOptions.find(p => p.type === 'COUPON');
    if (!coupon?.isValid) {
      if (!coupon.displayable) {
        setCouponIsEligible(false);
        setCouponError(DEAFULT_COUPON_ERROR_MESSAGE);
        return;
      }
      let message = coupon.error.message.title;

      for (const key in coupon.error.message.data) {
        message = message.replace(`{${key}}`, coupon.error.message.data[key]);
      }
      setCouponIsEligible(false);
      setCouponError(message);
    } else {
      setCouponIsEligible(true);
      setCouponDiscountAmmount(
        coupon.displayable ? `${coupon?.title} ${formatter.format(coupon?.amount / 100)}` : 'Έκπτωση απo κουπόνι'
      );
      setCouponDiscount({
        isValid: true,
        message: coupon.displayable ? coupon.title : 'Έκπτωση απo κουπόνι',
        amount: coupon.amount,
      });

      setCouponSuccess(`${t('checkout.coupon_success')} ${formatter.format(convertFromCents(coupon.amount))}`);
    }
  }

  if (res.error) {
    setCouponIsEligible(false);

    // TODO: handle with some form of error display
  }
}
